import { useLoaderData, useLocation, useSearchParams } from '@remix-run/react'
import { useEffect, useState } from 'react'
import Breadcrumb from '#app/components/breadcrumbs'
import { type loader } from '#app/routes/_public+/product+/$styleNumber'

interface ProductBreadcrumbsProps {}

const ProductBreadcrumbs = ({}: ProductBreadcrumbsProps) => {
	const [terms, setTerms] = useState<string[]>([''])
	const location = useLocation()
	const loaderData = useLoaderData<typeof loader>()
	const [searchParams] = useSearchParams()

	const productData = loaderData?.productData
	const productCategory = productData?.productInfo.categories[0].obj?.key
	const store = searchParams.get('store')
		? searchParams.get('store')?.split(',') || []
		: undefined

	const formatSegment = (segment: string) => {
		return segment
	}
	useEffect(() => {
		if (
			location.state &&
			location.state.previousURL &&
			productData?.name &&
			location.state.previousType === 'product'
		) {
			setTerms(location.state.previousURL.split('-').map(formatSegment))
		} else if (productCategory && productData?.name) {
			setTerms(productCategory.split('-').map(formatSegment))
		}
		setTerms(prev => [...prev, productData?.name || ''])

		return () => {
			setTerms([])
		}
	}, [location.state, productCategory, productData?.name])
	return (
		<div className=" mt-2 md:mt-2">
			<Breadcrumb pathSegments={terms} storeParams={store as string[]} />
		</div>
	)
}

export default ProductBreadcrumbs
